module.exports = __webpack_public_path__ + "static/media/amico.40202866.png";